import { render } from "./FrontHeader.vue?vue&type=template&id=42dc7348"
import script from "./FrontHeader.vue?vue&type=script&lang=js"
export * from "./FrontHeader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/frontend/mobileproject/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__